import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiFilteredAlert } from '../../api';

export interface FilteredAlertsState {
  alerts: ApiFilteredAlert[];
  filterId: number;
  isLoading: boolean;
}

export const initialState: FilteredAlertsState = {
  alerts: [],
  filterId: 0,
  isLoading: false,
};

const filteredAlertsSlice = createSlice({
  name: 'filteredAlerts',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    fetchFilteredAlertsSuccess: (state, action: PayloadAction<{ alerts: ApiFilteredAlert[]; filterId: number }>) => {
      state.alerts = action.payload.alerts;
      state.filterId = action.payload.filterId;
      state.isLoading = false;
    },
    fetchFilteredAlertsBatchSuccess: (state, action: PayloadAction<ApiFilteredAlert[]>) => {
      state.alerts = state.alerts.concat(action.payload);
      state.isLoading = false;
    },
    updateFilteredAlertSuccess: (state, action: PayloadAction<ApiFilteredAlert>) => {
      state.alerts = state.alerts.map((item) => {
        if (
          (item.screeningAlertId && item.screeningAlertId === action.payload.screeningAlertId) ||
          (item.monitoringAlertId && item.monitoringAlertId === action.payload.monitoringAlertId) ||
          (item.bridgeAlertId && item.bridgeAlertId === action.payload.bridgeAlertId) ||
          (item.manualAlertId && item.manualAlertId === action.payload.manualAlertId)
        ) {
          return action.payload;
        }

        return item;
      });
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = filteredAlertsSlice;
// Extract and export each action creator by name
export const { setLoading, fetchFilteredAlertsSuccess, fetchFilteredAlertsBatchSuccess, updateFilteredAlertSuccess } =
  actions;
// Export the reducer, either as a default or named export
export default reducer;
